// React, Redux y React Router DOM
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// Componentes
import SplashScreen from "../../components/base/SplashScreen";
import Login from "../../pages/login/LoginView";

// Utils
import { isAuthenticated } from "../../utils/tokenUtils";

// Imagenes
import { BackgroundMain as BackgroundImage, LogoMain } from "../../config/brandAssets";
// import LogoOasis from "../../../assets/LogoOasis.svg";

// Estilos
import {
  ContainerHome,
  ContainerLeft,
  BackgroundImg,
  ContainerLogin,
  ContainerLogoOverlay,
} from "./styles";

const HomeView = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const [showSplash, setShowSplash] = useState<boolean>(true);
  const [isEnglish, setIsEnglish] = useState<boolean>(i18n.language === "en");
  const [isCheckingSession, setIsCheckingSession] = useState<boolean>(true);

  // Verificar si hay una sesión válida al cargar
  useEffect(() => {
    const checkExistingSession = () => {
      if (isAuthenticated()) {
        // Reingreso con sesión activa: respetar la última ruta si existe.
        const lastRoute = localStorage.getItem("lastRoute");
        if (lastRoute && lastRoute !== "/" && lastRoute !== "/splash") {
          localStorage.removeItem("lastRoute");
          navigate(lastRoute, { replace: true });
          return;
        }
        navigate("/map", { replace: true });
      } else {
        setIsCheckingSession(false);
      }
    };

    checkExistingSession();
  }, [navigate]);

  // Mostrar el splash screen
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setIsEnglish(i18n.language === "en");
  }, [i18n.language]);

  // Mientras se verifica la sesión o se muestra el splash, mostrar SplashScreen
  if (isCheckingSession || showSplash) {
    return <SplashScreen />;
  }

  return (
    <ContainerHome>
      <ContainerLeft>
        {/* Mostrar el logo solo en desktop/laptop */}
        <ContainerLogoOverlay className="hidden md:flex">
          <img
            src={LogoMain}
            alt="Logo"
            className="w-[400px] h-auto drop-shadow-[0_8px_48px_rgba(0,0,0,0.95)]"
          />
        </ContainerLogoOverlay>
        <BackgroundImg src={BackgroundImage} alt="Background" />
      </ContainerLeft>
      <ContainerLogin>
        <Login isEnglish={isEnglish} setIsEnglish={setIsEnglish} />
      </ContainerLogin>
    </ContainerHome>
  );
};

export default HomeView;
